import React from "react";
import Header from "../../../components/Header/Header";
import {
  IconButton,
  Typography,
  StepConnector,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";
import "./mapData.scss";
import MapFooter from "../../../components/Footer/MapFooter";
import { bindActionCreators } from "redux";
import * as acts from "../../../redux/validator/actions";
import { connect } from "react-redux";
import "react-multi-carousel/lib/styles.css";
import ProgressBar from "../../../components/ProgressBar";
import ModalProcessor from "../../../components/Modal/RejectModal/ModalProcessor";
import CustomizedSnackbar from "../../../components/Snackbars/CustomizedSnackbars";
import DataValidationContainer from "./DataValidationContainer";
import { notification } from "../../../constants/notificationMessages";
import styled from "styled-components";
import HideImageOutlinedIcon from "@mui/icons-material/HideImageOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import { valiRoutes } from "../../../routes/routeConstants";
import AxiosServices from "../../../services/axiosServices";
const axiosService = new AxiosServices();

const ColorlibConnector = styled(StepConnector)({
  alternativeLabel: {},
  active: {
    "& $line": {
      borderBottom: "3px solid rgba(0,0,0,0.7)",
      fontWeight: 700,
    },
  },
  completed: {
    "& $line": {
      borderColor: "rgba(0,0,0,0.7)",
      borderBottom: "3px solid rgba(0,0,0,0.7)",
      borderTopWidth: "0px!important",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#B9B9B9",
    borderRadius: 1,
    borderTopWidth: "0px!important",
  },
});
class MapData extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      coorData: [],
      // isFullView: false,
      leftgrid: 6,
      rightgrid: 6,
      isFullScreen: true,
      hideScreen: true,
      openAuth: false,
      openSignPad: false,
      signUploaded: false,
      action: "",
      batchRejection: false,
      rejectionRemark: "",
      batch_for_qc: localStorage.getItem("batch_for_qc"),
      isMappingReviewEnabled: false,

      // assignToValidator:process.env.REACT_APP_VALIDATOR_FOR_QC
    };
    // Create the child instance using react createRef
    this.child = React.createRef();
    this.qcChild = React.createRef();
  }

  componentDidMount() {
    this.props.acts.clearApiStatus();
    this.props.acts.getValiData(localStorage.projectId, localStorage.batchId);
    this.props.acts.isSignatureUploaded();
    this.props.acts.validateUserClear();
    this.props.acts.clearIsSignatureUploadedStatus();
    this.fetchDrugTypes();
    // Set up the interval
    this.interval = setInterval(() => {
      // if (this.child.current) {
      // Ensure child is mounted before calling
      // this.onClickFooterAction("save", null, true);
      // }
    }, 120000); // 1 minute
  }

  fetchDrugTypes = async () => {
    try {
      const response = await axiosService.Get("api/drug-types/", {
        params: {
          name_exact: localStorage.getItem("drugType"),
        },
      });
      this.setState({
        isMappingReviewEnabled:
          response?.data?.data[0]?.enable_validation_review || false,
      });
    } catch (error) {
      console.error("Failed to fetch drug types:", error);
    }
  };

  componentWillUnmount() {
    // Clean up the interval
    clearInterval(this.interval);
  }

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   if (
  //     nextProps?.entireBatchRejectedByVali &&
  //     nextProps?.entireBatchRejectedByVali
  //   ) {
  //     this.setState({ batchRejection: nextProps?.entireBatchRejectedByVali });
  //   }
  //   if (nextProps?.apiStatus?.loader === true) {
  //     this.setState({
  //       loader: true,
  //     });
  //   }
  //   if (
  //     nextProps?.apiStatus?.loader === false &&
  //     (nextProps?.apiStatus?.messages === "error" ||
  //       nextProps?.apiStatus?.messages === "Server Error Please Try Again...")
  //   ) {
  //     this.setState({
  //       loader: false,
  //       sucessNotification: false,
  //       errorNotification: true,
  //       message: notification.somethingWentWrong,
  //     });
  //   }
  //   if (
  //     nextProps?.apiStatus.loader === false &&
  //     nextProps?.apiStatus.next === false &&
  //     nextProps?.apiStatus.message !== "" &&
  //     nextProps?.apiStatus.message !== null
  //   ) {
  //     this.setState({
  //       sucessNotification: true,
  //       message: notification.successMessage,
  //     });
  //   }
  //   if (
  //     nextProps?.apiStatus.loader === false &&
  //     nextProps?.apiStatus.next === true
  //   ) {
  //     this.setState({
  //       loader: false,
  //       sucessNotification: true,
  //       errorNotification: false,
  //       message: notification.successMessage,
  //     });

  //     setTimeout(() => {
  //       this.setState({
  //         sucessNotification: false,
  //         message: "",
  //       });
  //       this.props?.navigate("/validator-dashboard");
  //       this.props.acts.clearApiStatus();
  //     }, 2000);
  //   }
  //   if (
  //     nextProps?.apiStatus.loader === false &&
  //     nextProps?.apiStatus.message !== null &&
  //     nextProps?.apiStatus?.isError === true
  //   ) {
  //     this.setState({
  //       loader: false,
  //       sucessNotification: false,
  //       errorNotification: true,
  //       message: nextProps?.apiStatus.message,
  //     });
  //   }
  //   if (
  //     nextProps?.apiStatus?.loader === false &&
  //     nextProps?.apiStatus?.next === false &&
  //     nextProps?.apiStatus?.isRejected === true
  //   ) {
  //     this.setState({
  //       loader: false,
  //       sucessNotification: true,
  //       errorNotification: false,
  //       message: notification.successMessage,
  //     });

  //     setTimeout(() => {
  //       this.setState({
  //         sucessNotification: false,
  //         message: "",
  //       });
  //       this.props?.navigate("/validator-dashboard");
  //     }, 2000);
  //   }

  //   if (
  //     nextProps?.signUploaded?.isSignatureUploaded !== "" &&
  //     nextProps?.signUploaded?.isSignatureUploaded === true
  //   ) {
  //     this.setState({
  //       signUploaded: true,
  //     });
  //   }
  // }

  componentDidUpdate(prevProps) {
    const {
      entireBatchRejectedByVali,
      apiStatus,
      signUploaded,
      navigate,
      acts,
    } = this.props;

    // Update batch rejection state if it changes
    if (
      prevProps.entireBatchRejectedByVali !== entireBatchRejectedByVali
      // entireBatchRejectedByVali
      // && prevProps.entireBatchRejectedByVali !== entireBatchRejectedByVali
    ) {
      this.setState({ batchRejection: entireBatchRejectedByVali });
    }

    // Handle loader state
    if (
      apiStatus?.loader === true &&
      prevProps.apiStatus?.loader !== apiStatus.loader
    ) {
      this.setState({ loader: true });
    } else if (
      prevProps.apiStatus?.loader !== apiStatus?.loader &&
      apiStatus?.loader === false
    ) {
      this.setState({ loader: false });
    }

    // Error notification handling
    if (
      apiStatus?.loader === false &&
      apiStatus?.messages &&
      apiStatus !== prevProps.apiStatus
    ) {
      if (
        apiStatus.messages === "error" ||
        apiStatus.messages === "Server Error Please Try Again..."
      ) {
        this.setState({
          sucessNotification: false,
          errorNotification: true,
          message: notification.somethingWentWrong,
        });
      } else if (apiStatus.messages && apiStatus.next === false) {
        this.setState({
          sucessNotification: true,
          message: notification.successMessage,
        });
      }
    }

    // Successful completion and redirection
    if (
      apiStatus?.loader === false &&
      apiStatus?.next === true &&
      prevProps.apiStatus !== apiStatus
    ) {
      this.setState({
        sucessNotification: true,
        errorNotification: false,
        message: notification.successMessage,
      });

      setTimeout(() => {
        this.setState({
          sucessNotification: false,
          message: "",
        });
        // navigate(`/${valiRoutes.valiDashboard}`)
        // navigate(`/${valiRoutes.valiUserPermission}`);

        this.state.isMappingReviewEnabled
          ? navigate(`/${valiRoutes.valiUserPermission}`)
          : navigate(`/${valiRoutes.valiDashboard}`);

        acts.clearApiStatus();
      }, 2000);
    }

    // Specific error message handling
    if (
      apiStatus?.loader === false &&
      apiStatus?.isError === true &&
      apiStatus?.message !== null &&
      prevProps.apiStatus !== apiStatus
    ) {
      this.setState({
        sucessNotification: false,
        errorNotification: true,
        message: apiStatus.message,
      });
    }

    // Handle rejected cases
    if (
      apiStatus?.loader === false &&
      apiStatus?.next === false &&
      apiStatus?.isRejected === true &&
      prevProps.apiStatus !== apiStatus
    ) {
      this.setState({
        sucessNotification: true,
        errorNotification: false,
        message: notification.successMessage,
      });

      setTimeout(() => {
        this.setState({
          sucessNotification: false,
          message: "",
        });
        navigate(`/${valiRoutes.valiDashboard}`);
      }, 2000);
    }

    // Update signature upload state
    if (
      signUploaded?.isSignatureUploaded === true &&
      prevProps.signUploaded?.isSignatureUploaded !==
        signUploaded.isSignatureUploaded
    ) {
      this.setState({ signUploaded: true });
    }
  }

  onClickFooterAction = (action, e, autoSave = false) => {
    //data validation and Output File generation.
    if (action === "cancel") {
      // this.props.navigate("/validator-dashboard");
      this.props.navigate(`/${valiRoutes.valiDashboard}`);
    } else if (action === "reject") {
      if (!e.target.checked) {
        this.setState({
          batchRejection: false,
          rejectionRemark: "",
        });
      } else if (e.target.checked) {
        this.setState({
          openRejectionModal: true,
        });
      }
    } else {
      this.setState({
        action: action,
      });

      if (this.state?.batch_for_qc === "false" && this.child.current) {
        if (action === "saveAndNext") {
          if (this?.state?.batchRejection) {
            this.child.current.mapData(
              "reject",
              this?.state?.rejectionRemark,
              this?.state?.batchRejection,
            );
          } else if (this?.state?.batchRejection === false) {
            this.child.current.mapData(
              "saveAndNext",
              this?.state?.rejectionRemark,
              this?.state?.batchRejection,
              this?.state?.signUploaded,
            );
          }
        } else this.child.current.mapData(action, null, null, null, autoSave);
      } else if (this.state?.batch_for_qc === "true" && this.qcChild.current) {
        if (this?.state?.batchRejection) {
          // this.qcChild.current.mapData2(action, autoSave);

          this.qcChild.current.mapData2(
            "reject",
            this?.state?.rejectionRemark,
            this?.state?.batchRejection,

            false, // autoSave,
          );

          // if entire batch is rejected
        } else this.qcChild.current.mapData2(action, "", false, autoSave);
      }
    }
  };

  handleCloseModal = () => {
    this.setState({
      openRejectionModal: false,
      batchRejection: false,
    });
  };

  handleReject = (remark) => {
    this.setState({
      openRejectionModal: false,
      batchRejection: true,
      rejectionRemark: remark,
    });
  };

  // handleCloseFullView = () => {
  //   this.setState({ isFullView: false });
  // };

  // handleOpenFullView = () => {
  //   this.setState({ isFullView: true });
  // };
  handleCloseSignPad = () => {
    this.setState({ openSignPad: false });
    this.props.acts.isSignatureUploaded();
  };

  slideScreentoMaximize = () => {
    this.setState({ rightgrid: 12 });
    this.setState({ isFullScreen: false });
    this.setState({ hideScreen: false });
  };
  slideScreentoMinimize = () => {
    this.setState({ leftgrid: 6 });
    this.setState({ rightgrid: 6 });
    this.setState({ isFullScreen: true });
    this.setState({ hideScreen: true });
  };

  render() {
    return (
      <div>
        <Header />
        <div className="fullscreen-view">
          {this.state.isFullScreen ? (
            <div
            //  className="slide-button"
            >
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => this.slideScreentoMaximize()}
              >
                <ImageOutlinedIcon />
              </IconButton>

              {/* <Buttons
                size="small"
                onClick={() => this.slideScreentoMaximize()}
                text="Hide PDF"
                startIcon={<ArrowLeftIcon />}
                variant="outlined"
              /> */}
            </div>
          ) : (
            <div
            // className="slide-button"
            >
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => this.slideScreentoMinimize()}
              >
                <HideImageOutlinedIcon />
              </IconButton>

              {/* <Buttons
                size="small"
                onClick={() => this.slideScreentoMinimize()}
                text="Show PDF"
                startIcon={<ArrowRightIcon />}
                variant="outlined"
              /> */}
            </div>
          )}
          <Typography className="project-batch-header">
            {localStorage.projectName + " - " + localStorage.batchName}
          </Typography>

          {/* <IconButton aria-label="fullView">
            <Typography className="current-step"> Data Validation</Typography>
          </IconButton> */}
          <Stepper
            activeStep={this.state.activeStep}
            connector={<ColorlibConnector />}
          >
            <Step key="Data Validation" className="stepper-wrap-label">
              <StepLabel>Data Validation</StepLabel>
            </Step>
          </Stepper>
        </div>
        {/* {this?.state?.isFullView ? (
          <Dialog
            fullScreen={true}
            open={this?.state?.isFullView}
            aria-labelledby="responsive-dialog-title"
            keepMounted={true}
          >
            <DialogActions className="dialog-style">
              {this.state.isFullScreen ? (
                <div className="slide-button">
                  <Buttons
                    size="small"
                    onClick={() => this.slideScreentoMaximize()}
                    text="Hide PDF"
                    startIcon={<ArrowLeftIcon />}
                  />
                </div>
              ) : (
                <div className="slide-button">
                  <Buttons
                    size="small"
                    onClick={() => this.slideScreentoMinimize()}
                    text="Show PDF"
                    startIcon={<ArrowRightIcon />}
                  />
                </div>
              )}
              <IconButton
                className="fullview-close"
                aria-label="close"
                onClick={this.handleCloseFullView}
              >
                <CloseIcon />
              </IconButton>
            </DialogActions>

            <DialogContent className="fullscreen-table-wrap">
              <DataValidationContainer
                child={this.child}
                isFullView={this?.state?.isFullView}
                hideScreen={this?.state?.hideScreen}
                leftgrid={this?.state?.leftgrid}
                rightgrid={this?.state?.rightgrid}
              />
            </DialogContent>
          </Dialog>
        ) : ( */}
        <DataValidationContainer
          child={this?.child}
          qcChild={this?.qcChild}
          // isFullView={this?.state?.isFullView}
          hideScreen={this?.state?.hideScreen}
          leftgrid={this?.state?.leftgrid}
          rightgrid={this?.state?.rightgrid}
          // assignToValidator={this.state.assignToValidator}
        />
        {/* )} */}

        <MapFooter
          pdfCount={this.props?.coorData.length}
          isDisableMultipageMappingLable={true}
          onClickFooterAction={this.onClickFooterAction}
          batchRejection={this.state.batchRejection}
        />

        {this.props?.apiStatus?.loader ? <ProgressBar /> : ""}
        {this.state.openRejectionModal && (
          <ModalProcessor
            modalOpen={this.state.openRejectionModal}
            handleClose={this.handleCloseModal}
            handleReject={this.handleReject}
            isShowClearButton={false}
            disableDeleteRejection={true}
            isShowDeleteButton={false}
            heading={"Do you want to reject the batch?"}
          />
        )}
        {this.state?.sucessNotification && (
          <CustomizedSnackbar
            severity="success"
            state={this.state?.sucessNotification}
            text={this.state?.message}
            handleClose={() =>
              this.setState({
                sucessNotification: false,
              })
            }
          />
        )}
        {this.state?.errorNotification && (
          <CustomizedSnackbar
            severity="error"
            state={this.state?.errorNotification}
            text={this.state.message}
            handleClose={() =>
              this.setState({
                errorNotification: false,
              })
            }
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    acts: bindActionCreators(acts, dispatch),
  };
};

function mapStateToProps(state) {
  return {
    coorData: state.vali?.coorData?.coordinatesDetails || [],
    apiStatus: state.vali?.apiStatus,
    signUploaded: state.vali?.signUploaded,
    entireBatchRejectedByVali:
      state.vali?.coorData?.mapping_details?.entireBatchRejectedByVali,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MapData);
